//@ts-nocheck
import { useState, useEffect } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  BlogSection,
  ArticleWrap,
  BlogWrapContent,
  MenuWrap
} from '@components/Fblog.styles';
import { LogoWhite } from '@assets/svgs';
import Modal from '@components/Modal';
import { Thecopymodal } from '@components/ModalCopy';
import { CWriting } from '@data/copywriting';
import { BlogItemsBigEvent } from '@components/BlogitemsBigEvent';
import Menu from '@components/Menu/index';
import Footer from '@components/Footer';

import george_profile from '@assets/george.jpg';

const GeorgeMartins: NextPage = () => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 100);
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <Layout
        showHeader
        showCopyheader
        animationHeader="header"
        showFashionDesktop
        showMenu
        color="#000"
        email="george.martins@jorgedd.com"
        whatAppmsg="Hi George Martins,%0a%0aI would like to talk about my project with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0aMy number:"
        whatAppLink="I'm looking forward to speak about your project. Click here to connect with me!"
        logo={<LogoWhite />}
      >
        <BlogSection>
          <ArticleWrap>
            <div className={scroll ? 'onScrollBottomMenu' : 'onScrollTopMenu'}>
              <h1>Blog.</h1>
              <MenuWrap>
                <Menu
                  showCopywritingMenu
                  subscribeText="Subscribing to our news and latest. Be the first to know about what’s
            happening in the fashion world. The most talented Designers,
            Shows and the most talented Fashion Writers."
                />
              </MenuWrap>
            </div>

            <BlogWrapContent>
              <p style={{ width: '100%' }}>PROFILE</p>
              <br />
              <br />
              <h2>George Martin's</h2>
              <br />
              <br />
              <Image
                src={george_profile}
                width={1900}
                height={2525}
                alt="Ward 4"
                style={{ width: '120px', height: '120px', borderRadius: '50%' }}
              />
              <br/>
              <p style={{ width: '100%' }}>Fashion Writer | Copywirter | Technical Writer</p>
              <br />
              <br />
              <p style={{ width: '100%' }}>
                I’m George Martins, I am a writer and I don’t just write—I
                transform ideas into compelling narratives that drive action. At
                Martin’s, we specialize in Fashion Writing, Copywriting, and
                Tech Writing, helping brands, businesses, and innovators
                communicate with impact. Whether it's crafting high-fashion
                editorials, persuasive sales copy, or simplifying complex tech
                for a wider audience, we bring creativity, precision, and
                strategy to every word. AI can generate text, but it can’t
                capture vision, emotion, or brand identity as we do. Let’s
                create content that speaks, sells, and sets you apart.
              </p>
              <br />
              <br />
              <Link
                href="https://www.linkedin.com/in/jorgeddmartins"
                target="_blank"
                className="btn"
              >
                LinkedIn Profile
              </Link>
            </BlogWrapContent>
          </ArticleWrap>
          <Footer isClass="footer" />
        </BlogSection>
      </Layout>
    </>
  );
};

export default GeorgeMartins;
